import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@services';
import { passwordConfirm } from '@shared/validator/password-confirm.validator';
import { password } from '@shared/validator/password.validator';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent {
  @Input() token: string = '';
  @Input() resetForm: boolean = false;
  @Output() resetFormEmit: EventEmitter<any> = new EventEmitter();
  @Output() isValid: EventEmitter<boolean> = new EventEmitter();
  public passwordForm: FormGroup;
  public isOpen = false;
  public newPasswordOnFocus = false;
  public validLength: boolean;
  public validNumber: boolean;
  public validUppercase: boolean;
  public validSpecial: boolean;
  public validPassword: boolean;
  public passMessage = '';

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this.reInit();
  }

  ngOnInit(): void {
    const validOldPass = this.token === '' ? [Validators.required] : [];
    this.passwordForm = this.formBuilder.group({
      oldPassword: ['', validOldPass],
      newPassword: [
        '',
        [
          Validators.required,
          password,
          passwordConfirm('repeatNewPassword', true),
        ],
      ],
      repeatNewPassword: [
        '',
        [Validators.required, password, passwordConfirm('newPassword')],
      ],
    });
  }

  checkValid(): void {
    const newPassword = this.passwordForm.controls['newPassword'].value;
    const repeatNewPassword =
      this.passwordForm.controls['repeatNewPassword'].value;

    newPassword.length >= 8
      ? (this.validLength = true)
      : (this.validLength = false);

    /\d/.test(newPassword)
      ? (this.validNumber = true)
      : (this.validNumber = false);

    /[A-Z]/.test(newPassword)
      ? (this.validUppercase = true)
      : (this.validUppercase = false);

    /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(newPassword)
      ? (this.validSpecial = true)
      : (this.validSpecial = false);

    this.validPassword =
      this.validLength &&
      this.validNumber &&
      this.validUppercase &&
      this.validSpecial;
    if (!this.validPassword) this.passMessage = 'Inválida';
    else if (repeatNewPassword === '') {
      this.passMessage = 'Ingresar Repetir contraseña';
      this.validPassword = false;
    } else if (repeatNewPassword !== newPassword) {
      this.passMessage = 'Contraseñas distintas';
      this.validPassword = false;
    } else this.passMessage = 'Válida';
  }

  async save() {
    if (this.passwordForm.valid) {
      try {
        const { oldPassword, newPassword, repeatNewPassword } =
          this.passwordForm.value;
        if (newPassword === repeatNewPassword) {
          let response: any;
          if (this.token === '') {
            response = await this.authService.changePassword({
              oldPassword,
              newPassword,
            });
          } else {
            response = await this.authService.changePasswordWithToken(
              newPassword,
              this.token
            );
          }
          this.isValid.emit(true);
        }
      } catch (error) {
        this.isValid.emit(false);
      }
    }
  }

  reInit() {
    if (this.resetForm) {
      if (this.passwordForm) this.passwordForm.reset();
      this.validPassword = undefined;
      setTimeout(() => {
        this.resetFormEmit.emit();
      });
    }
  }
}
